export enum PessoaOutroNomeTipo {
  ALCUNHA = 'ALCUNHA',
  NOME_SOCIAL = 'NOME_SOCIAL',
  OUTRO = 'OUTRO'
}
